import { Root } from 'mdast'
import { fromMarkdown } from 'mdast-util-from-markdown'
import { gfmStrikethrough } from 'micromark-extension-gfm-strikethrough'
import { gfmStrikethroughFromMarkdown } from 'mdast-util-gfm-strikethrough'
import { mdxJsx } from 'micromark-extension-mdx-jsx'
import { mdxJsxFromMarkdown } from 'mdast-util-mdx-jsx'

/**
 * parseMarkdownToAST - parse a markdown string to a mdast abstract syntax tree
 *
 * @param {string} markdown - the markdown to parse
 *
 * @return {Root} the abstract syntax tree
 */
export function parseMarkdownToAST(markdown: string): Root {
	return fromMarkdown(markdown, MDAST_OPTIONS)
}

// options used by mdast to parse the markdown
const MDAST_OPTIONS = {
	extensions: [gfmStrikethrough(), mdxJsx()],
	mdastExtensions: [gfmStrikethroughFromMarkdown(), mdxJsxFromMarkdown()],
}
